import { NgModule } from 'ng-metadata/core';
import { AutotipDirective } from './autotip.tooltip.directive';
import { HelpdeskComponent } from './helpdesk.tooltip.component';
import { InfotipComponent } from './infotip.tooltip.component';
import './tooltip.scss';

/**
 * @ngdoc module
 * @name mw.components.tooltip
 * @description
 *
 * Tooltips
 */
@NgModule({
    declarations: [ AutotipDirective, HelpdeskComponent, InfotipComponent ]
})
export class TooltipModule {}




// WEBPACK FOOTER //
// ./src/lib/components/tooltip/tooltip.module.ts